export type UserRole = 'student' | 'teacher' | 'admin'
export type UserStatus = 'active' | 'blocked' | 'deleted'

export interface Profile {
  first_name: string
  last_name: string
  display_name: string | null
  grade: number | null
  timezone: string
  theme: 'system' | 'light' | 'dark'
}

export interface User {
  id: string
  email: string
  role: UserRole
  status: UserStatus
  email_verified: boolean
  created_at: string
  last_login_at: string | null
  profile: Profile
}

export interface AuthResponse {
  user: User
  csrf_token: string
  access_expires_in: number
}

export interface SessionInfo {
  id: string
  created_at: string
  last_seen_at: string
  ip: string | null
  user_agent: string | null
  current: boolean
}

export const ROLE_LABELS: Record<UserRole, string> = {
  student: 'Ученик',
  teacher: 'Учитель',
  admin: 'Администратор',
}

export function fullName(user: User): string {
  const { first_name, last_name, display_name } = user.profile
  return display_name ?? [first_name, last_name].filter(Boolean).join(' ')
}
